var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"flex gap-5 text-sm"},[_vm._l((_vm.items),function(item,index){return [_c('router-link',{key:index,attrs:{"to":item.route}},[_c('li',[_vm._v(_vm._s(item.name))])]),(index !== _vm.items.length - 1)?_c('span',[_vm._v("|")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }